import React, { FC, useCallback, useState } from "react";
import { TabsProps } from "./tab.types";
import { UncontrolledTabs } from "./uncontrolled-tabs";

const MODE_CONTROLLED = 0;
const MODE_UNCONTROLLED = 1;

/**
 * `Tabs` are used to organize information into smaller, more focused segments.
 */
export const Tabs: FC<TabsProps> = ({
  children,
  ripple,
  defaultActiveIndex = 0,
  activeIndex: activeIndexProp,
  maxTabsOnMobile = 2,
  onActivate,
  className,
  variant = "horizontal",
  color = "interactive",
  ...restProps
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);
  const [mode] = useState<0 | 1>(() =>
    activeIndexProp || activeIndexProp === 0 ? MODE_CONTROLLED : MODE_UNCONTROLLED
  );

  const handleSelected = useCallback(
    (event, index, last) => {
      if (typeof onActivate === "function") {
        onActivate(event, index, last);
      }

      if (mode === MODE_UNCONTROLLED) {
        setActiveIndex(index);
      }
      return true;
    },
    [mode, onActivate]
  );

  return (
    <UncontrolledTabs
      ripple={ripple}
      activeIndex={mode === MODE_UNCONTROLLED ? activeIndex : activeIndexProp}
      maxTabsOnMobile={maxTabsOnMobile}
      onActivate={handleSelected}
      variant={variant}
      color={color}
      className={className}
      {...restProps}
    >
      {children}
    </UncontrolledTabs>
  );
};
